import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

// Translated by Park Seok Ho

var ko = {
  language: 'ko',
  country: 'kr',
  name: '한국어',
  embeddedLocale: merge(error, login),
  flags: ['KR'],
};

export { ko as default };
